import { Component, Inject } from '@angular/core';
import { Validators } from '@angular/forms';
import { ControlBase } from '../../base/control-base/control-base.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { ICoreService } from '../../../interfaces/core-service.interface';
import { BugReportModel } from 'angular-core-src/types/bug-report-model';
import { firstValueFrom } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { CoreService_TOKEN } from '../../../tokens/injection-tokens';
import { ExtendedFormGroup } from 'angular-core-src/base-classes/extended-form-group.class';
import { ExtendedFormControl } from 'angular-core-src/base-classes/extended-form-control.class';
@Component({
    selector: 'bug-report-form-control',
    templateUrl: 'bug-report-form.control.html',
    standalone: false,
})
export class BugReportFormControl extends ControlBase {
    public bugReportForm: ExtendedFormGroup<BugReportModel> = this.getFormGroup();

    constructor(
        @Inject(CoreService_TOKEN)
        private coreService: ICoreService,
        protected override spinnerService: NgxSpinnerService
    ) {
        super(spinnerService);
    }
    public ngOnInit(): void {
        this.initFormGroup();
    }
    private initFormGroup() {
        this.bugReportForm = this.getFormGroup();
    }
    public getFormGroup() {
        let res = new ExtendedFormGroup('bug-report-form', BugReportModel, {
            name: new ExtendedFormControl('name', '', [Validators.required]),
            description: new ExtendedFormControl('description', '', [Validators.required, Validators.minLength(10), Validators.maxLength(2000)]),
        });
        return res;
    }
    public submitBugReport = async (): Promise<void> => {
        if (this.bugReportForm.validateAllFormFields()) {
            let model: BugReportModel = new BugReportModel();
            let formValue: BugReportModel = this.bugReportForm.getValue();
            model.description = formValue.description;
            model.name = formValue.name;
            model.extensionName = this.settings.applicationName;
            this.handleSpinner(
                firstValueFrom(this.coreService.updateBugReport(model))
                    .then(res => {
                        this.initFormGroup();
                        this.ioc.core.notificationService.createSuccessTranslateMessage('bug_report_form.save_success');
                    })
                    .catch((err: HttpErrorResponse) => {
                        this.ioc.core.notificationService.createDangerTranslateMessage('bug_report_form.save_failed');
                    })
            );
        }
    };
}
